// extracted by mini-css-extract-plugin
export var bodyCopy = "relatedContentCard-module--bodyCopy--2b341";
export var buttons = "relatedContentCard-module--buttons--9d102";
export var dark = "relatedContentCard-module--dark--703d7";
export var eyebrow = "relatedContentCard-module--eyebrow--39067";
export var hasImage = "relatedContentCard-module--hasImage--ce64a";
export var headline = "relatedContentCard-module--headline--e6d9f";
export var hoverImageContainer = "relatedContentCard-module--hoverImageContainer--00acd";
export var light = "relatedContentCard-module--light--2dbcf";
export var relatedContentCard = "relatedContentCard-module--relatedContentCard--c5bf4";
export var relatedContentLink = "relatedContentCard-module--relatedContentLink--05042";